export const sanitize = (slug: string) => {
  return slug
    .replace(/[^a-zA-Z0-9-:/]/g, '')
    .replace(/\s+/g, '_')
    .toLowerCase()
}
